import { debounce, memoize, escapeRegExp } from 'lodash';

// TODO: this optimization may be a  bit overkill and could be removed

export const text2Expressions = memoize((text) => {
        let result = [];
        for (let word of text.split(/\W/)) {
            word = word.trim();
            if (word.length) {
                result.push(new RegExp(escapeRegExp(word), 'i'));
            }
        }
        return result;
    }),
    triggerMemoizationsCacheClear = debounce(() => {
        text2Expressions.cache.clear();
    }, 30000);
